import React from 'react'
import WaitlistButton from './WaitlistButton'

function WaitlistSection(props) {
  return (
    <div className="lp-container">
        <div className="input-section subsc-input">
            <div>
                <input
                type="text"
                name={props.name}
                id={props.name}
                value={props.email}
                onChange={(e)=>{props.setEmail(e.target.value)}}
                placeholder="Enter your email"
                className="mail-input"
                />
            </div>
            <WaitlistButton waitlist={props.waitlist}/>
        </div>
    </div>
  )
}

export default WaitlistSection
